import { CheckCircle2, XCircle } from 'lucide-react'

const ROWS = [
  {
    feature: 'Plano gratuito',
    us: { value: 'Buscas ilimitadas', positive: true },
    a: { value: 'Com anúncios', positive: false },
    b: { value: 'Limitado', positive: null },
  },
  {
    feature: 'IA entende intenção',
    us: { value: 'IA proprietária', positive: true },
    a: { value: 'Filtros manuais', positive: false },
    b: { value: 'Filtros manuais', positive: false },
  },
  {
    feature: 'Transparência da fonte',
    us: { value: 'Mostra site de origem', positive: true },
    a: { value: 'Esconde', positive: false },
    b: { value: 'Parcial', positive: null },
  },
  {
    feature: 'Submeter vaga grátis',
    us: { value: 'Empresa/PJ qualquer', positive: true },
    a: { value: 'Pago', positive: false },
    b: { value: 'Pago', positive: false },
  },
  {
    feature: 'LGPD compliance',
    us: { value: 'Auditado', positive: true },
    a: { value: 'Parcial', positive: null },
    b: { value: 'Parcial', positive: null },
  },
]

function Cell({ value, positive }: { value: string; positive: boolean | null }) {
  return (
    <td className="px-4 py-3.5 text-sm text-center">
      <span className="flex items-center justify-center gap-1.5 flex-wrap">
        {positive === true && (
          <CheckCircle2 className="h-4 w-4 text-green-500 flex-shrink-0" aria-hidden="true" />
        )}
        {positive === false && (
          <XCircle className="h-4 w-4 text-red-400 flex-shrink-0" aria-hidden="true" />
        )}
        <span
          className={
            positive === true
              ? 'text-green-700 dark:text-green-400 font-medium'
              : positive === false
                ? 'text-red-600 dark:text-red-400'
                : 'text-gray-500 dark:text-gray-400'
          }
        >
          {value}
        </span>
      </span>
    </td>
  )
}

export function ComparisonTable() {
  return (
    <section
      className="py-16 md:py-24 relative overflow-hidden bg-gradient-to-b from-slate-50 to-white dark:from-slate-900/40 dark:to-zinc-950"
      aria-labelledby="comparison-heading"
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-16">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-blue-50 border border-blue-100 dark:bg-blue-950/30 dark:border-blue-900/50 px-3 py-1 text-[10px] md:text-xs font-semibold uppercase tracking-widest text-blue-600 dark:text-blue-300 mb-3 md:mb-4">
            Comparativo honesto
          </span>
          <h2
            id="comparison-heading"
            className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 tracking-tight text-slate-900 dark:text-white"
          >
            Como nos posicionamos no mercado
          </h2>
          <p className="text-slate-600 dark:text-slate-400 text-base md:text-lg leading-relaxed">
            Sem marketing vazio — só os fatos.
          </p>
        </div>

        <div className="max-w-4xl mx-auto overflow-x-auto rounded-2xl border border-gray-200 dark:border-white/10 shadow-lg">
          <table className="w-full min-w-[560px] border-collapse bg-white dark:bg-slate-900">
            <caption className="sr-only">Comparação de funcionalidades entre plataformas</caption>
            <thead>
              <tr className="border-b border-gray-100 dark:border-white/5">
                <th
                  scope="col"
                  className="px-4 py-3.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 w-1/4"
                >
                  Recurso
                </th>
                <th
                  scope="col"
                  className="px-4 py-3.5 text-center text-xs font-semibold uppercase tracking-wider text-blue-600 dark:text-blue-400 bg-blue-50/60 dark:bg-blue-950/20 w-1/4"
                >
                  AcheiVagas
                </th>
                <th
                  scope="col"
                  className="px-4 py-3.5 text-center text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 w-1/4"
                >
                  Concorrente 01
                </th>
                <th
                  scope="col"
                  className="px-4 py-3.5 text-center text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 w-1/4"
                >
                  Concorrente 02
                </th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row, i) => (
                <tr
                  key={row.feature}
                  className={`border-b border-gray-50 dark:border-white/5 last:border-0 ${
                    i % 2 === 0
                      ? 'bg-white dark:bg-slate-900'
                      : 'bg-slate-50/50 dark:bg-slate-800/20'
                  }`}
                >
                  <th
                    scope="row"
                    className="px-4 py-3.5 text-left text-sm font-medium text-gray-700 dark:text-gray-200"
                  >
                    {row.feature}
                  </th>
                  <td className="px-4 py-3.5 text-sm text-center bg-blue-50/30 dark:bg-blue-950/10">
                    <span className="flex items-center justify-center gap-1.5 flex-wrap">
                      <CheckCircle2
                        className="h-4 w-4 text-green-500 flex-shrink-0"
                        aria-hidden="true"
                      />
                      <span className="text-green-700 dark:text-green-400 font-semibold">
                        {row.us.value}
                      </span>
                    </span>
                  </td>
                  <Cell value={row.a.value} positive={row.a.positive} />
                  <Cell value={row.b.value} positive={row.b.positive} />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}
